<style scoped lang="scss">

</style>

<template>
    <vk-modal :show.sync="isOpen" v-if="form">
        <div class="uk-grid">
            <div class="uk-width-1-1 uk-margin-top">
                <h2>Add New {{ roleName }}</h2>
                <span v-if="applicationRoleId === 3"><small>This is who you pay your rent to.</small></span>
            </div>
            <div class="uk-width-1-1 uk-margin-top">
                <label for="name">What information do you have for your {{ roleName }}?:</label>
                <select v-model="whatInformationDoYouHave" @change="onChangeType" class="uk-select uk-form-large">
                    <option :value="null">Make a Selection</option>
                    <option :value="1">I know the Company</option>
                    <option :value="2">I know the Person</option>
                    <option :value="3">I know both</option>
                </select>
            </div>
            <div class="uk-width-1-1 uk-margin-top" v-if="whatInformationDoYouHave == 1 || whatInformationDoYouHave == 3">
                <validated-section :errors="errors" field="organization.organization_name">
                    <label for="name">{{ roleName }} Company Name<span class="uk-text-danger uk-text-bold">*</span> :</label>
                    <text-input name="Company Name" v-model="form.company_name" placeholder="Enter Company Name"></text-input>
                </validated-section>
            </div>
            <div class="uk-width-1-2 uk-margin-top" v-if="whatInformationDoYouHave == 2 || whatInformationDoYouHave == 3">
                <validated-section :errors="errors" field="person.first_name">
                    <label for="name">{{ roleName }} First Name<span class="uk-text-danger uk-text-bold">*</span> :</label>
                    <text-input name="First Name" v-model="form.first_name" placeholder="Enter First Name"></text-input>
                </validated-section>
            </div>
            <div class="uk-width-1-2 uk-margin-top" v-if="whatInformationDoYouHave == 2 || whatInformationDoYouHave == 3">
                <validated-section :errors="errors" field="person.last_name">

                <label for="name">{{ roleName }} Last Name<span class="uk-text-danger uk-text-bold">*</span> :</label>
                    <text-input name="Last Name" v-model="form.last_name" placeholder="Enter Last Name"></text-input>
                </validated-section>
            </div>

            <div class="uk-width-1-2 uk-margin-top" v-if="whatInformationDoYouHave !== null">
                <validated-section :errors="errors" field="person.email" >
                    <label for="name">{{ roleName }} Email Address :</label>
                    <text-input name="Email Address" v-model="form.email" placeholder="Enter Email Address" type="email"></text-input>
                </validated-section>
            </div>
            <div class="uk-width-1-2 uk-margin-top" v-if="whatInformationDoYouHave !== null">
                <validated-section :errors="errors" field="person.phone">
                    <label for="name">{{ roleName }} Phone Number :</label>
                    <phone-number-input
                        name="Phone" 
                        v-model="form.phone"
                        @onInputChange="onPhoneChanged"
                        placeholder="">
                    </phone-number-input>
                </validated-section>
            </div>

            <div class="uk-width-1-2 uk-margin-top" v-if="whatInformationDoYouHave !== null">
                <validated-section :errors="errors" field="organization.address.address_1">
                    <label for="name">{{ roleName }} Address Line 1 :</label>
                    <text-input name="Address1"  v-model="form.address_1" placeholder="Enter Address Line 1"/>
                </validated-section>
            </div>
            <div class="uk-width-1-2 uk-margin-top" v-if="whatInformationDoYouHave !== null">
                <validated-section :errors="errors" field="organization.address.address_2">
                    <label for="name">{{ roleName }} Address Line 2 :</label>
                    <text-input name="Address2" v-model="form.address_2" placeholder="Enter Address Line 2"/>
                </validated-section>
            </div>
            <div class="uk-width-1-2 uk-margin-top" v-if="whatInformationDoYouHave !== null">
                <validated-section :errors="errors" field="organization.address.city">
                    <label for="name">{{ roleName }} City :</label>
                    <text-input name="City" v-model="form.city" placeholder="Enter City"/>
                </validated-section>
            </div>
            <div class="uk-width-1-2 uk-margin-top" v-if="whatInformationDoYouHave !== null">
                <validated-section :errors="errors" field="organization.address.state_id">
                    <label for="role">{{ roleName }} State : <br></label>
                    <select v-model="form.state_id" class="uk-width-1-1 uk-form-large">
                            <option v-for="state in states" :value="state.id" :selected="form.state_id === state.id">
                                {{ state.name }}
                            </option>
                    </select>
                </validated-section>
            </div>
            <div class="uk-width-1-2 uk-margin-top" v-if="whatInformationDoYouHave !== null">
                <validated-section :errors="errors" field="organization.address.zip">
                    <label for="name">{{ roleName }}  Zip :</label> <br>
                    <text-input name="Zip" v-model="form.zip" id="zip" placeholder="Enter ZIP"/>
                </validated-section>
            </div>
        </div>

        <div slot="footer" class="uk-text-right">
            <vk-button class="uk-margin-small-right" @click="isOpen = false">{{ cancelText }}</vk-button>
            <vk-button type="primary" @click="save">{{ confirmText }}</vk-button>
        </div>
    </vk-modal>
</template>

<script>


    import {mapState} from "vuex";
    import ValidatedSection from "../../Common/ValidatedSection";
    export default {
        name: "CreatePropertyContactModal",
        components: {ValidatedSection},
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            cancelText: {
                type: String,
                default: 'CANCEL',
            },
            confirmText: {
                type: String,
                default: 'SAVE',
            },
            applicationRoleId: {
                type: Number,
                required: true,
            },
            table: {
                type: String,
                required: true,
            },
            prefix: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                isOpen: false,
                whatInformationDoYouHave: null,
                hasInfoAboutCompany: false,
                hasInfoAboutPerson: true,
                errors: {},
                form: {
                    phone: '',
                },
                states: [
                    { id: '', name: 'Select State'},
                    { id: 1, name: 'Alabama'},
                    { id: 2, name: 'Alaska'},
                    { id: 3, name: 'Arizona'},
                    { id: 4, name: 'Arkansas'},
                    { id: 5, name: 'California'},
                    { id: 6, name: 'Colorado'},
                    { id: 7, name: 'Connecticut'},
                    { id: 8, name: 'Delaware'},
                    { id: 9, name: 'District of Columbia'},
                    { id: 10, name: 'Florida'},
                    { id: 11, name: 'Georgia'},
                    { id: 12, name: 'Hawaii'},
                    { id: 13, name: 'Idaho'},
                    { id: 14, name: 'Illinois'},
                    { id: 15, name: 'Indiana'},
                    { id: 16, name: 'Iowa'},
                    { id: 17, name: 'Kansas'},
                    { id: 18, name: 'Kentucky'},
                    { id: 19, name: 'Louisiana'},
                    { id: 20, name: 'Maine'},
                    { id: 21, name: 'Maryland'},
                    { id: 22, name: 'Massachusetts'},
                    { id: 23, name: 'Michigan'},
                    { id: 24, name: 'Minnesota'},
                    { id: 25, name: 'Mississippi'},
                    { id: 26, name: '1'},
                    { id: 27, name: 'Montana'},
                    { id: 28, name: 'Nebraska'},
                    { id: 29, name: 'Nevada'},
                    { id: 30, name: 'New Hampshire'},
                    { id: 31, name: 'New Jersey'},
                    { id: 32, name: 'New Mexico'},
                    { id: 33, name: 'New York'},
                    { id: 34, name: 'North Carolina'},
                    { id: 35, name: 'North Dakota'},
                    { id: 36, name: 'Ohio'},
                    { id: 37, name: 'Oklahoma'},
                    { id: 38, name: 'Oregon'},
                    { id: 39, name: 'Pennsylvania'},
                    { id: 40, name: 'Rhode Island'},
                    { id: 41, name: 'South Carolina'},
                    { id: 42, name: 'South Dakota'},
                    { id: 43, name: 'Tennessee'},
                    { id: 44, name: 'Texas'},
                    { id: 45, name: 'Utah'},
                    { id: 46, name: 'Vermont'},
                    { id: 47, name: 'Virginia'},
                    { id: 48, name: 'Washington'},
                    { id: 49, name: 'West Virginia'},
                    { id: 50, name: 'Wisconsin'},
                    { id: 51, name: 'Wyoming'},
                    { id: 52, name: 'England (Country)'},
                    { id: 53, name: 'Manitoba (Canada)'},
                ]
            }
        },
        computed: {
            roleName() {
                if(this.applicationRoleId == 3) {
                    return 'Landlord/Property Manager';
                }
                if(this.applicationRoleId == 4) {
                    return 'Property Owner';
                }
                return '';
            },
            ...mapState('Application', {
                assets: state => state.assets,
                applicationId: state => state.application.id,
                application: state => state.application,
            }),
            ...mapState('Landlord', {
                confirmation: state => state.confirmation,
            })
        },
        methods: {
            onChangeType() {
                this.form.company_name = ''
                this.form.first_name = ''
                this.form.last_name = ''
            },

            openEdit(contact) {
                this.form = contact;
                this.isOpen = true;
            },
            open() {
                let fields = {
                    company_name: '',
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                    address_1: '',
                    address_2: '',
                    city: '',
                    state_id: null,
                    state: '',
                    zip: '',
                };
                let form = {};
                for(let field in fields) {
                    form[field] = fields[field];
                }
                this.form = form;
                this.isOpen = true;
            },

            onConfirm() {

            },

            onPhoneChanged($event) {
                console.log($event);
                if($event.isValid) {
                    this.form.phone.area_code = $event.number.input.substr(0, 3);
                    this.form.phone.phone_number = $event.number.input.substr(3, 7);
                }
            },

            async save() {
                this.errors = {}
                this.$emit('beforeSubmit');
                setTimeout(async () => {
                    let data = {
                        type: this.whatInformationDoYouHave,
                        organization: {
                            organization_name: this.form.company_name,
                            phone: this.form.phone,
                            address: {
                                line_1: this.form.address_1,
                                line_2: this.form.address_2,
                                city: this.form.city,
                                state_id: this.form.state_id,
                                zip: this.form.zip,
                            }
                        },
                        person: {
                            first_name: this.form.first_name,
                            last_name: this.form.last_name,
                            email: this.form.email,
                            phone: this.form.phone,
                        },
                        role_id: this.applicationRoleId,
                    };


                    if(this.table == 'household_applications') {
                        let url = `/api/hope/applications/${this.applicationId}/contacts`;
                        try {
                            let r = await axios.post(url, data);
                        }catch(e) {
                            this.errors = e.response.data.errors;
                            return;
                        }
                    } else {
                        let url = `/api/landlord/${this.confirmation.id}/contacts`;
                        try {
                            let r = await axios.post(url, data);
                        }catch(e) {
                            this.errors = e.response.data.errors;
                            return;
                        }
                    }


                    this.$emit('done');
                    this.isOpen = false;
                }, 1500);

            },
        }
    }
</script>
